import { Component } from '@angular/core';

@Component({
  selector: 'app-graphic-designing',
  imports: [],
  templateUrl: './graphic-designing.component.html',
  styleUrl: './graphic-designing.component.scss',
})
export class GraphicDesigningComponent {}
